import React, { useEffect } from 'react'
import { getReasonCategory } from './constants/constant';
import { FormControl, MenuItem } from '@mui/material';
import { StyledSelect } from '../../styles/commonStyles';

function OccasionList(props: any) {
    const [occasionList, setOccasionList] = React.useState<any[]>([]);
    const {occasion, setOccasion, module, actionType} = props
    
    const fetchOccasionList = React.useCallback(async () => {
        let sampleReasonSubReason = await getReasonCategory(module, actionType);
        setOccasionList(sampleReasonSubReason);   
    }, [module, actionType]);
    
    useEffect(() => {
        fetchOccasionList();
    }, [fetchOccasionList]);
  return (
    <FormControl sx={{width: "100%"}}>
        <StyledSelect
            labelId="type"
            id="type"
            label="Occasion"
            value={occasion}
            variant='outlined'
            onChange={(event: any) => {
                setOccasion(event.target.value);
            }}
        >
            {occasionList.map((d: any) => (
                <MenuItem key={d} value={d?.category}>
                    {d?.category}
                </MenuItem>
            ))}
        </StyledSelect>
    </FormControl>
  )
}

export default OccasionList
